import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { booksClient, saveBooksSession, errMsg } from './api';

const BooksResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const token = params.get('token') || '';

  useEffect(() => {
    if (!token) toast.error('Reset link is missing or expired');
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('Password must be at least 8 characters');
    if (password !== confirm) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      const { data } = await booksClient.post('/auth/reset-password', { token, password });
      saveBooksSession(data.token, data.user, data.tenant);
      toast.success('Password updated. Signing you in…');
      navigate('/books/app/dashboard');
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050b12] text-slate-100" data-testid="books-reset-page">
      <div className="pointer-events-none fixed inset-0 overflow-hidden">
        <div className="absolute -top-40 left-1/2 h-[500px] w-[500px] -translate-x-1/2 rounded-full bg-emerald-500/20 blur-[120px]" />
      </div>
      <div className="relative z-10 mx-auto flex min-h-screen max-w-md flex-col items-center justify-center px-6">
        <Link to="/books" className="mb-8 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-400 to-emerald-600 font-bold text-white">EB</div>
          <div className="text-lg font-semibold">Emerald Books</div>
        </Link>
        <div className="w-full rounded-2xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur">
          <form onSubmit={submit}>
            <div className="mb-2 text-2xl font-semibold text-white">Set a new password</div>
            <div className="mb-6 text-sm text-slate-400">
              Choose a strong password. At least 8 characters.
            </div>
            <label className="mb-1 block text-xs text-slate-400">New password</label>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mb-4 border-white/10 bg-white/[0.03] text-white"
              data-testid="reset-password-input"
            />
            <label className="mb-1 block text-xs text-slate-400">Confirm password</label>
            <Input
              type="password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="mb-4 border-white/10 bg-white/[0.03] text-white"
              data-testid="reset-confirm-input"
            />
            <Button
              type="submit"
              disabled={loading || !token}
              className="h-11 w-full rounded-full bg-emerald-500 font-semibold text-white hover:bg-emerald-400"
              data-testid="reset-submit"
            >
              {loading ? 'Updating…' : 'Update password'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BooksResetPasswordPage;
